import { type VariantProps, cva } from "class-variance-authority";

import { clsx } from "@ala/core/utils/clsx";

const spinnerVariants = cva(
  "spinner-blade absolute bottom-0 left-1/2 h-[0.2em] w-[0.05em] origin-[center_-0.3em] animate-[spinner-blade-fade_infinite_linear]",
  {
    variants: {
      variant: {
        contrast: "bg-contrast-900",
        white: "bg-white",
        currentColor: "bg-current",
      },
    },
    defaultVariants: {
      variant: "contrast",
    },
  },
);

export const Spinner = ({ className, variant }: { className?: string } & VariantProps<typeof spinnerVariants>) => {
  const bladeCount = 12;
  const duration = 1;

  return (
    <div className={clsx("spinner relative block size-[1em] text-xl", className)}>
      {Array.from({ length: bladeCount }).map((_, index) => (
        <div
          key={index}
          className={spinnerVariants({ variant })}
          style={{
            transform: `translateX(-50%) rotate(${index * (360 / bladeCount)}deg)`,
            animationDelay: `${index * (duration / bladeCount)}s`,
            animationDuration: `${duration}s`,
          }}
        />
      ))}
    </div>
  );
};
